/* Detailing1 — Tooltip für den „Frag die KI"-Sparkle-Button in der Suchleiste.
   Zeigt beim Hover/Tastatur-Fokus (Desktop) bzw. beim Fokus des Suchfelds
   (mobil/Touch) einen Hinweis, was der Klick macht. Der Text ist dynamisch:
   ist etwas getippt, nennt er den Suchbegriff; sonst ein allgemeiner Hinweis.
   Liest dieselbe .js-search-input wie ai-search-chat.js, damit Hinweis und
   tatsächlich gesendeter Text übereinstimmen.
   Isoliert + Init-Guard; unterdrückt den nativen title (Doppel-Tooltip).
   Rausnehmen = revert.py — das Intercom-Feature bleibt unberührt. */
(function () {
  if (window.__d1AiSearchTip) return;
  window.__d1AiSearchTip = true;

  var SPARKLE =
    '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
    '<path fill="currentColor" d="M6.13 1.87 Q6.81 5.99 10.93 6.67 Q6.81 7.34 6.13 11.47 Q5.46 7.34 1.33 6.67 Q5.46 5.99 6.13 1.87Z"/>' +
    '<path fill="currentColor" d="M12.47 1.93 Q12.72 3.48 14.27 3.73 Q12.72 3.99 12.47 5.53 Q12.21 3.99 10.67 3.73 Q12.21 3.48 12.47 1.93Z"/>' +
    '<path fill="currentColor" d="M11.73 9.0 Q12.08 11.12 14.2 11.47 Q12.08 11.81 11.73 13.93 Q11.39 11.81 9.27 11.47 Q11.39 11.12 11.73 9.0Z"/></svg>';

  var noHover = !!(window.matchMedia && window.matchMedia('(hover: none)').matches);
  var tip, titleEl, subEl, arrowEl, currentBtn = null, hideTimer = null;

  function build() {
    tip = document.createElement('div');
    tip.className = 'd1-ai-tip';
    tip.setAttribute('role', 'tooltip');
    tip.innerHTML =
      '<div class="d1-ai-tip__row"><span class="d1-ai-tip__icon">' + SPARKLE +
      '</span><span><span class="d1-ai-tip__title"></span>' +
      '<span class="d1-ai-tip__sub"></span></span></div>' +
      '<span class="d1-ai-tip__arrow"></span>';
    document.body.appendChild(tip);
    titleEl = tip.querySelector('.d1-ai-tip__title');
    subEl = tip.querySelector('.d1-ai-tip__sub');
    arrowEl = tip.querySelector('.d1-ai-tip__arrow');
  }

  function inputFor(btn) {
    var form = btn.closest('form');
    return (form && form.querySelector('.js-search-input')) ||
      document.querySelector('.js-search-input');
  }

  function setText(btn) {
    var input = inputFor(btn);
    var t = input ? input.value.trim() : '';
    if (t) {
      if (t.length > 38) t = t.slice(0, 38).trim() + '…';
      titleEl.textContent = '„' + t + '" im Chat fragen';
      subEl.textContent = 'Daniel antwortet dir';
    } else {
      titleEl.textContent = 'Direkt fragen statt suchen';
      subEl.textContent = 'Chat mit Daniel öffnen';
    }
  }

  function place(btn) {
    var r = btn.getBoundingClientRect();
    var tr = tip.getBoundingClientRect();
    var gap = 10, margin = 8;
    var top = r.top - tr.height - gap, below = false;
    if (top < 6) { top = r.bottom + gap; below = true; }
    var center = r.left + r.width / 2;
    var left = Math.max(margin, Math.min(center - tr.width / 2, window.innerWidth - tr.width - margin));
    tip.style.top = Math.round(top) + 'px';
    tip.style.left = Math.round(left) + 'px';
    var ax = Math.max(12, Math.min(center - left - 5, tr.width - 22));
    arrowEl.style.left = Math.round(ax) + 'px';
    if (below) {
      arrowEl.style.top = '-5px'; arrowEl.style.bottom = 'auto';
      arrowEl.style.transform = 'rotate(225deg)';
    } else {
      arrowEl.style.top = 'auto'; arrowEl.style.bottom = '-5px';
      arrowEl.style.transform = 'rotate(45deg)';
    }
  }

  function show(btn) {
    if (!tip) build();
    if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
    currentBtn = btn;
    if (btn.getAttribute('title')) btn.removeAttribute('title');
    setText(btn);
    tip.style.visibility = 'hidden';
    tip.classList.add('is-visible');
    requestAnimationFrame(function () {
      if (currentBtn !== btn) return;
      place(btn);
      tip.style.visibility = 'visible';
    });
  }

  function hide() { if (tip) { currentBtn = null; tip.classList.remove('is-visible'); } }
  function hideSoon() { hideTimer = setTimeout(hide, 90); }

  function btnFrom(el) { return el && el.closest ? el.closest('[data-ai-search-chat]') : null; }
  function isSearchInput(el) { return el && el.classList && el.classList.contains('js-search-input'); }

  function stripTitles() {
    var list = document.querySelectorAll('[data-ai-search-chat][title]');
    for (var i = 0; i < list.length; i++) list[i].removeAttribute('title');
  }

  document.addEventListener('mouseover', function (e) { var b = btnFrom(e.target); if (b) show(b); });
  document.addEventListener('mouseout', function (e) { if (btnFrom(e.target)) hideSoon(); });
  document.addEventListener('focusin', function (e) {
    var b = btnFrom(e.target);
    if (b) { show(b); return; }
    if (noHover && isSearchInput(e.target)) {
      var form = e.target.closest('form');
      var sb = form && form.querySelector('[data-ai-search-chat]');
      if (sb) show(sb);
    }
  });
  document.addEventListener('focusout', function (e) {
    if (btnFrom(e.target) || isSearchInput(e.target)) hideSoon();
  });
  document.addEventListener('input', function (e) {
    if (currentBtn && isSearchInput(e.target)) { setText(currentBtn); place(currentBtn); }
  });
  document.addEventListener('click', function (e) { if (btnFrom(e.target)) hide(); });
  window.addEventListener('scroll', function () { if (currentBtn) hide(); }, { capture: true, passive: true });
  window.addEventListener('resize', function () { if (currentBtn) place(currentBtn); });

  if (document.readyState !== 'loading') stripTitles();
  else document.addEventListener('DOMContentLoaded', stripTitles);
})();
